import { CategoryColor } from '@models/TagCategory.model';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { beam } from '@styles/colors/themes';
import styled, { css } from 'styled-components';
import { ReactComponent as CloseImage } from '@assets/svg/small-cross.svg';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';
import { deviceTypes } from '@styles/mediaQueries';

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 10;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  width: 100%;
  height: 100%;
  max-width: 50rem;
  max-height: 40rem;
  align-self: center;
  justify-self: center;
  z-index: 10;
  position: fixed;
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 12px 28px rgba(33, 39, 73, 0.2);
  border-radius: 8px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  grid-template-columns: minmax(min-content, 500px) 1fr;

  row-gap: 16px;

  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Title = styled.div`
  color: #161a30;
  font-size: 18px;
  font-weight: 600;
  flex: 1;
`;

export const Close = styled.button`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  padding: 0;
  padding-top: 6px;

  transition: 0.2s;

  :hover {
    background-color: ${COLORS_FLAT.b100};
  }
`;
Close.displayName = 'Close';
export const Back = styled.img`
  cursor: pointer;
`;

interface ILabel {
  status?: string;
}

export const Label = styled.div<ILabel>`
  font-size: 14px;
  font-weight: 400;
  color: #474d66;

  &.light {
    font-weight: 500;
    font-size: 12px;
    color: #8f95b2;
  }
`;

export const Line = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 28px;
`;

interface IConfirm {
  disabled?: boolean;
}

export const Confirm = styled.button<IConfirm>`
  height: 42px;
  padding: 0 16px;
  color: ${({ disabled }) => (disabled ? '#c1c4d6' : '#fff')};
  background-color: ${({ disabled }) => (disabled ? '#edeff4' : '#1371FE')};
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  font-size: 14px;
`;

export const Cancel = styled.button`
  display: flex;
  padding: 10px 16px;
  background-color: transparent;
  border: none;
  border-radius: 8px;
  color: #474d66;
  font-size: 14px;
  font-weight: 500;
  margin-right: 8px;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;

  &.light {
    align-items: center;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

interface IInput {
  isError?: boolean;
  isLink?: boolean;
}

export const Input = styled.input<IInput>`
  display: flex;
  width: 331px;
  height: 36px;
  border: 1px solid
    ${({ isError }) => (isError ? beam.border.error : '#d8dae5')};
  border-radius: 8px;
  padding: 10px 12px 10px 12px;
  font-size: 12px;

  color: ${({ isLink }) => (isLink ? beam.color.primaryBlue : '#474d66')};
  text-decoration-line: ${({ isLink }) => (isLink ? 'underline' : 'unset')};

  transition: all 0.2s;

  ::placeholder {
    color: #8f95b2;
  }
  &.infoInputs {
    width: 100%;
  }
`;
export const SelectFile = styled.label`
  display: flex;
  width: 90px;
  height: 36px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  color: #696f8c;
  background: #fff;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  box-sizing: border-box;

  z-index: 12;

  margin-left: -90px;

  ::-webkit-file-upload-button {
    display: none;
  }

  transition: 0.2s;
  :hover {
    filter: brightness(0.9);
  }
`;

export const FileName = styled.div`
  width: 300px;
  height: 36px;
  border-radius: 8px;
  font-size: 14px;
  display: flex;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  color: #474d66;
  background: #fff;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 12px;
  border: 1px solid #d8dae5;
`;

export const IconCloseAwesome = styled(FontAwesomeIcon)`
  position: absolute;
  background: white;
  width: 24px !important;
  padding: 1px 6px;
  right: 0px;
  cursor: pointer;
`;

export const ProfileImg = styled.img`
  width: 62px;
  height: 62px;
  border-radius: 32px;

  margin-right: 24px;
  object-fit: cover;
`;

export const Form = styled.form`
  width: 100%;
`;

interface IDivider {
  height?: string;
  width?: string;
}

export const Divider = styled.div<IDivider>`
  height: ${({ height }) => height};
  width: ${({ width }) => width};
`;
export const SpacingDivider = styled.div`
  width: 16px;
`;

export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FileImage = styled.img`
  width: 12px;
  height: 16px;
  margin-bottom: -4px;
`;

export const HolderDiv = styled.div`
  display: flex;
  flex-direction: row;
  height: 22px;
`;

export const Wrap = styled.div`
  grid-gap: 8px;
  margin-left: -4px;
  /* margin-bottom: 24px; */

  [data-device='${deviceTypes.mobile}'] & {
    overflow: auto;
    display: flex;
    flex-shrink: 0;
    flex-wrap: nowrap;
  }
`;

interface ITag {
  color?: string;
}

export const Tag = styled.div<ITag>`
  height: 30px;
  padding: 0 12px;
  border-radius: 15px;
  background: ${({ color }) => color};
  color: ${({ color }) => {
    if (color === '#E7E4F9') return '#524988';
    if (color === '#DCF2EA') return '#317159';
    if (color === '#FFEFD2') return '#66460D';
    if (color === '#D3F5F7') return '#0F5156';
    if (color === '#F8E3DA') return '#85462B';
    if (color === '#FBDDF3') return '#8E3374';
    if (color === '#F9DADA') return '#7D2828';
    if (color === '#E6EDFF') return '#1F3D99';
    return '#474d66';
  }};
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  width: min-content;
  cursor: pointer;
  margin: 4px;
`;

export const DeleteIcon = styled.div`
  height: 20px;
  margin-left: 10px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  position: relative;
`;

interface IInputSearch {
  search?: boolean;
  clear?: boolean;
}

export const InputSearch = styled.input<IInputSearch>`
  border-radius: 8px;
  padding-left: 32px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #d8dae5;
  height: 42px;
  color: #474d66;
  font-size: 14px;
  width: 100%;

  &::placeholder {
    color: #8f95b2;
  }

  ${({ search }) =>
    search &&
    css`
      padding-right: 66px;
    `}
  ${({ clear }) =>
    clear &&
    css`
      padding-right: 36px;
    `}
`;

export const SearchIconContainer = styled.div`
  position: absolute;
  left: 12px;
`;

export const AddButton = styled.button`
  display: flex;
  height: 42px;
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid #d8dae5;
  background-color: transparent;
  gap: 8px;
`;

export const ButtonText = styled.div`
  color: #474d66;
  font-size: 14px;
  font-weight: 500;
`;

export const LineDivider = styled.div`
  width: 100%;
  margin-bottom: 16px;
  border-bottom: 1px solid #e6e8f0;
`;

export const Tags = styled.div`
  height: 300px;
  flex: 1;
  overflow: auto;
  margin-right: -10px;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const LoadMore = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-items: center;
  justify-content: center;
  align-content: center;
  flex-direction: row;
`;

export const LoadingText = styled.div`
  border-radius: 8px;
  margin-right: 8px;
  border: none;
  font-size: 12px;
  color: #696f8c;
  text-align: center;
`;

export const LoadingImg = styled.img`
  height: 14px;
  width: 14px;
`;

export const CloseImg = styled(CloseImage)`
  cursor: pointer;
  margin-left: -30px;
  margin-right: 9px;
  height: 20px;
  width: 20px;
  padding: 2px;
  border-radius: 4px;
  transition: 0.2s;

  :hover {
    background-color: ${COLORS_FLAT.b100};
  }
`;
CloseImg.displayName = 'CloseImg';
export const NoTags = styled.div`
  font-weight: 300;
  font-size: 14px;
  color: #8f95b2;
  font-style: italic;
  height: 30px;
  margin: 4px;
  margin-left: 12px;
`;

export const TagCategory = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
`;

export const CategoryLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1b203a;
`;

export const Empty = styled.div`
  font-weight: 300;
  font-size: 14px;
  color: #8f95b2;
  font-style: italic;
`;

export const Spacing = styled.div`
  margin-bottom: 8px;
  align-items: center;
`;

export const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Item = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 16px;
  margin-top: 16px;
  cursor: pointer;
`;

export const ChevronDiv = styled.div`
  display: flex;
`;

interface IColor {
  color?: CategoryColor;
}

export const Color = styled.div<IColor>`
  display: flex;
  align-self: center;
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background-color: ${({ color }) => color || '#edeff4'};
`;

export const ColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

export const IconContainer = styled.div`
  display: flex;
  padding-top: 6px;
`;

interface IText {
  light?: boolean;
  limitOfLines?: number;
}

export const Text = styled.div<IText>`
  font-size: 14px;
  font-weight: ${({ light }) => (light ? '400' : '500')};
  color: ${({ light }) => (light ? '#474d66' : '#1b203a')};

  &.subText {
    font-weight: 400;
    font-size: 12px;
    color: #8f95b2;
  }

  &.noDescription {
    font-weight: 400;
    font-size: 12px;
    color: #8f95b2;
    font-style: italic;
    margin-bottom: -3px;
  }

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;

export const Table = styled.div`
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;
